<div class="breadcrumb-container">
  <div class="row">
    <div class="col-lg-12">
      <h1>Analytics Chart Details</h1>
      <ol class="breadcrumb" id="breadcrumbNav">
        <li>
          <a [routerLink]="['/home']">
            <i class="fa fa-home"></i>
            <span>ProManual </span>
          </a>
        </li>
        <li class="active">
          <i class="fa fa-map-marker"></i>
          <span>Analytics Chart Details</span>
        </li>
      </ol>
    </div>
  </div>
</div>
<div class="component-container heightcls" style="overflow: hidden">
  <div class="well" style="height: 100%">
    <div class="row" style="height: 100%">
      <div class="col-xs-12 col-md-3 col-lg-2" style="height: 100%">
        <div class="panel panel-info" style="height: 100%">
          <div class="panel-heading">Charts</div>
          <ul
            class="list-unstyled side-nav"
            style="max-height: calc(100% - 56px); overflow: auto"
          >
            <li *ngFor="let chartSection of filteredAndSortedSections">
              <span class="chart-nav-header">{{
                chartSection.type.toString()
              }}</span>
              <ul class="list-unstyled">
                <li
                  *ngFor="let entry of chartSection.charts"
                  style="position: relative"
                >
                  <a
                    href="#"
                    (click)="onSelect($event, entry.key)"
                    [class.current-item]="entry.key === currentSectionKey"
                  >
                    <span>{{ entry.section.title }}</span>
                  </a>
                  <div
                    style="
                      position: absolute;
                      right: 1em;
                      top: 50%;
                      transform: translateY(-50%);
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      gap: 5px;
                      color: rgb(212, 228, 239);
                    "
                  >
                    <i
                      *ngIf="entry.type.indexOf('line') !== -1"
                      class="fa fa-line-chart"
                      aria-hidden="true"
                    ></i>
                    <i
                      *ngIf="entry.type.indexOf('pie') !== -1"
                      class="fa fa-pie-chart"
                      aria-hidden="true"
                    ></i>
                    <i
                      *ngIf="entry.type.indexOf('list') !== -1"
                      class="fa fa-table"
                      aria-hidden="true"
                    ></i>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="col-xs-12 col-md-9 col-lg-10"
        style="height: 100%; position: relative"
      >
        <div class="panel panel-info" style="height: 100%">
          <div class="panel-heading">
            <h5
              style="display: inline-block"
              *ngIf="
                currentSectionKey &&
                sections[currentSectionKey]?.shortDescription
              "
            >
              <b>{{ currentTitle }}</b> -
              {{ sections[currentSectionKey].shortDescription }}
              <button
                style="
                  margin-left: 3px;
                  width: 20px;
                  height: 20px;
                  background-color: #444;
                  color: white;
                  border: none;
                  border-radius: 50% !important;
                  font-size: 12px;
                  text-align: center;
                  line-height: 20px;
                  padding: 0;
                  display: inline-block;
                  vertical-align: middle;
                "
                title="More Info"
                (click)="onInfoClick()"
              >
                i
              </button>
            </h5>
            <div
              class="btn pull-right"
              (click)="clearChart()"
              title="Clear Chart"
              *ngIf="currentSectionKey"
            >
              <i class="fa fa-times"></i>
            </div>
            <div
              *ngIf="currentTitle !== '' && formattedExportOptions.length > 0"
              class="pull-right"
              style="margin-left: 15px; margin-right: 3em"
            >
              <div
                *ngIf="exporting"
                style="display: inline-block; margin-right: 10px"
              >
                <i class="fa fa-spinner fa-spin"></i>
              </div>
              <div *ngIf="!exporting" class="dropdown">
                <a href="" class="dropdown-toggle" data-toggle="dropdown">
                  <span>Export</span>
                  <b class="caret"></b>
                </a>
                <ul class="dropdown-menu">
                  <ng-container
                    *ngIf="
                      formattedExportOptions.length === 1;
                      else multipleCharts
                    "
                  >
                    <li *ngFor="let type of formattedExportOptions[0].types">
                      <a
                        (click)="
                          onExportClick(
                            formattedExportOptions[0].chart,
                            type.value
                          )
                        "
                      >
                        <span>{{ type.label }}</span>
                      </a>
                    </li>
                  </ng-container>
                  <ng-template #multipleCharts>
                    <ng-container *ngFor="let option of formattedExportOptions">
                      <li class="dropdown-header">{{ option.chart }}</li>
                      <li *ngFor="let type of option.types">
                        <a (click)="onExportClick(option.chart, type.value)">
                          <span>{{ type.label }}</span>
                        </a>
                      </li>
                    </ng-container>
                  </ng-template>
                </ul>
              </div>
            </div>
            <div
              *ngIf="currentTitle !== ''"
              class="pull-right"
              style="margin-left: 15px; margin-right: 3em"
            >
              <div style="display: inline-block; margin-right: 10px">
                <a (click)="refreshChart()" style="cursor: pointer"
                  ><i
                    class="fa fa-fw fa-solid fa-rotate-right"
                    title="Refresh"
                  ></i>
                  <span>Refresh</span></a
                >
              </div>
            </div>
          </div>
          <div
            class="panel-body"
            style="height: calc(100% - 56px); overflow: auto"
            *ngIf="currentTitle !== ''"
          >
            <div style="height: 100%; width: 100%">
              <ng-container
                *ngComponentOutlet="currentComponent"
              ></ng-container>
            </div>
          </div>
          <div
            class="panel-body"
            style="height: calc(100% - 56px); position: relative"
            *ngIf="currentTitle === ''"
          >
            <div
              style="
                display: flex;
                flex-flow: row nowrap;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                align-items: center;
                justify-content: space-between;
              "
            >
              <div
                style="
                  color: rgb(212, 228, 239);
                  position: absolute;
                  right: 125%;
                  top: 50%;
                "
              >
                <i class="fa fa-arrow-left fa-4x"></i>
              </div>
              <div>
                <div
                  style="
                    display: flex;
                    flex-flow: row nowrap;
                    color: rgb(212, 228, 239);
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <i class="fa fa-line-chart fa-4x"></i>
                  <i class="fa fa-pie-chart fa-4x"></i>
                  <i class="fa fa-area-chart fa-4x"></i>
                  <i class="fa fa-bar-chart-o fa-4x"></i>
                </div>
                <div style="display: flex; flex-direction: row">
                  <h2 style="color: grey">Click on a chart to begin</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- modal overlay -->
  <div
    *ngIf="
      showFullDescription &&
      currentSectionKey &&
      sections[currentSectionKey]?.fullDescription
    "
    (click)="closeFullDescription()"
    style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1050;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <!-- modal box -->
    <div
      (click)="$event.stopPropagation()"
      style="
        background: white;
        padding: 24px;
        border-radius: 12px !important;
        max-width: 700px;
        max-height: 80vh;
        overflow-y: auto;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
      "
    >
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <h4 style="margin: 0">{{ currentTitle }} Details</h4>
        <button
          style="
            border: none;
            background: none;
            font-size: 20px;
            cursor: pointer;
          "
          (click)="closeFullDescription()"
          title="Close"
        >
          &times;
        </button>
      </div>
      <div
        [innerHTML]="sections[currentSectionKey].fullDescription"
        style="font-size: 14px"
      ></div>
    </div>
  </div>
</div>
